import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "volume",
  "use": "volume-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"volume\">\n<path d=\"M11,20c-0.2,0-0.4-0.1-0.6-0.2L5.6,16H2c-0.6,0-1-0.4-1-1V9c0-0.6,0.4-1,1-1h3.6l4.7-3.8c0.3-0.2,0.7-0.3,1.1-0.1\n\tC11.8,4.3,12,4.6,12,5v14c0,0.4-0.2,0.7-0.6,0.9C11.3,20,11.1,20,11,20z M3,14h3c0.2,0,0.4,0.1,0.6,0.2l3.4,2.7V7.1L6.6,9.8\n\tC6.4,9.9,6.2,10,6,10H3V14z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol